module.exports = __webpack_public_path__ + "img/1.d5a449e9.png";